import gsap from 'gsap';

const navToggle = {
  nav: null,
  toggle: null,

  setNavState: (toggle, nav, isOpen) => {
    const opacity = isOpen ? 0 : 1;

    if (!isOpen) {
      document.body.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      nav.style.display = 'flex';
    } else {
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    gsap.to(nav, {
      opacity: opacity,
      duration: 0.2,
      ease: 'power3.out',
      onComplete: () => {
        if (isOpen) {
          nav.style.display = 'none';
        }
      } 
    });
  },

  toggleNav: (toggle, nav) => {
    const t = toggle || navToggle.toggle;
    const n = nav || navToggle.nav;
    if (!t || !n) return;
    const isOpen = document.body.classList.contains('nav-open');
    navToggle.setNavState(t, n, isOpen);
  },

  handleHashNavigation: (event, toggle, nav) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || !nav.contains(link)) return;

    const url = new URL(link.href, window.location.origin);
    const isSamePage =
      window.location.pathname.replace(/^\//, '') === url.pathname.replace(/^\//, '') &&
      window.location.hostname === url.hostname;

    if (!isSamePage || !url.hash) return;

    const targetId = url.hash.slice(1);
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    const scrollToTarget = () => {
      const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY);
      window.scrollTo({ top, behavior: 'smooth' });
      window.history.replaceState(null, '', `#${targetId}`);
    };

    if (window.innerWidth < 768 && document.body.classList.contains('nav-open')) {
      navToggle.setNavState(toggle, nav, true);
      window.setTimeout(scrollToTarget, 220);
      return;
    }

    scrollToTarget();
  },

  init: () => {
    const nav = document.getElementById('toggle-nav');
    const toggle = document.getElementById('nav-toggle');

    if (!nav || !toggle || nav.classList.contains('init')) return;

    nav.classList.add('init');
    toggle.setAttribute('aria-expanded', 'false');

    navToggle.nav = nav;
    navToggle.toggle = toggle;

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      navToggle.toggleNav(toggle, nav);
    });

    nav.addEventListener('click', (event) => {
      navToggle.handleHashNavigation(event, toggle, nav);
    });

    window.addEventListener('resize', function (event) {
      if (window.innerWidth >= 768) {
        navToggle.setNavState(toggle, nav, true);
      }
    });

    document.onkeyup = (event) => {
      if (window.innerWidth < 768) {
        if (event.key === 'Escape') {
          navToggle.setNavState(toggle, nav, true);
        }
      }
    };
  },
};

export default navToggle;
